import { ModalityTypes } from '@/models/catalog/course';
import type { ExternalCourseFormSchema } from '@/packages/subsidy/pages/refund-request/steps/resource-description/steps/external-item-form/components/course/schema';

interface CourseResourcePayloadParams {
  formValues?: ExternalCourseFormSchema | null;
  resourceType: string;
}

export const courseResource = ({
  formValues,
  resourceType,
}: CourseResourcePayloadParams) => {
  const hasAddress =
    formValues?.modality === ModalityTypes.Hybrid ||
    formValues?.modality === ModalityTypes.InPerson;

  return {
    type: resourceType,
    name: formValues?.course ?? '',
    request_reason: formValues?.request_reason ?? '',
    link: formValues?.link ?? '',
    amount: formValues?.amount ?? 0,
    sale_type: formValues?.sale_type ?? '',
    data: {
      course: {
        ...(hasAddress && {
          address: {
            campus: formValues?.campus,
            city: formValues?.city,
            state: formValues?.state,
          },
        }),
        course_type: formValues?.course_type,
        duration: formValues?.duration,
        duration_type: formValues?.duration_type,
        institution_name: formValues?.institution,
        modality: formValues?.modality,
        period: formValues?.period,
        source: 'external',
        workload: formValues?.workload,
      },
    },
  };
};
